<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkboxConfig="{
        highlight: false,
      }"
      :expand-config="{ reserve: true }"
      class="order-goods-tbale"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openDetailDialog', {
                  type: 'detail',
                  code: row.orderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openDetailDialog', {
                  type: 'edit',
                  code: row.orderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.orderGoodsCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(orderGoodsCode) {
      this.$emit('batchDel', [orderGoodsCode])
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.orderGoodsCode
        })
      }
      return data
    },
    onMousedown() {
      this.$refs.vxeGrid.clearRowExpand()
    },
  },
}
</script>
<style lang="scss" scoped>
.order-goods-tbale .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
